export const ORGANISATIONS_DEFAULT_PAGE_SIZE = 5

export const getIsVatNumber = (value: string) => {
  return (
    value.length == 9 &&
    value.split('').every((element: string) => !isNaN(Number(element)))
  )
}
